import { apiFetch } from './client';

export type ThemePreference = 'light' | 'dark' | null;

interface MeResponse {
  user_id: string;
  email: string;
  theme_preference: ThemePreference;
}

export interface Me {
  userId: string;
  email: string;
  themePreference: ThemePreference;
}

export async function getMe(token: string | null): Promise<Me> {
  const res = await apiFetch<MeResponse>('/api/v1/me', { token });
  return {
    userId: res.user_id,
    email: res.email,
    themePreference: res.theme_preference,
  };
}

// Persist the user's chosen theme on the server. Pass `null` to clear the
// preference and fall back to the browser's prefers-color-scheme.
export async function updateTheme(
  token: string | null,
  theme: 'light' | 'dark' | null,
): Promise<void> {
  await apiFetch<void>('/api/v1/me/theme', {
    method: 'PUT',
    body: { theme },
    token,
  });
}
